import Vue from 'vue'
import LoadingSVG from '@/assets/loading.svg'
export default new Vue({
    methods: {
        connect(shortkey) {
            this.shortkey = shortkey
            this.ws = new WebSocket(`${this.protocol}://${this.host}:${this.port}/video-edition?c=${shortkey}`)
            this.ws.onmessage = this.onDataHandler.bind(this)
            this.ws.onerror = this.onErrorHandler.bind(this)
            this.ws.onopen = this.onOpenHandler.bind(this)
            this.ws.onclose = this.onCloseHandler.bind(this)
        },
        send(data) {
            this.ws.send(JSON.stringify(data))
        },
        close() {
            try { this.ws.close() } catch (e) {}
        },
        onOpenHandler() {
            this.$emit('open')
            setInterval(() => {
                console.log('[SEND PING]')
                this.send({ kind: 'ping' })
            }, 60 * 1000)
        },
        onDataHandler(ev) {
            let { kind, cmd, data } = JSON.parse(ev.data)
            if (kind === 'pong') return;
            if (cmd === 'log') return console.log(`LOG: ${data}`)
            this.$emit('data', { kind, cmd, data })
        },
        onErrorHandler(err) {
            console.log(err)
                // this.$emit('error', err) err.vue로 연결
            alert('화상서버 연결에 실패하였습니다')
        },
        onCloseHandler() {
            this.$emit('close')
        }
    },
    created() {
        let { VUE_APP_WS_PROTOCOL, VUE_APP_WS_HOST, VUE_APP_WS_PORT } = process.env
        this.protocol = VUE_APP_WS_PROTOCOL
        this.host = VUE_APP_WS_HOST
        this.port = VUE_APP_WS_PORT
        this.ws = null
    },
    data() {
        return {
            shortkey: null,
            protocol: null,
            host: null,
            port: null,
            ws: null,
            supporter: null,
            servernum: null,
            error: '',
            loading: LoadingSVG,
            geolocation: null
        }
    }
})